import i18n from '../i18n';

export default class CodeType {
  public static readonly JANCODE = new CodeType('1', 'JANコード');
  public static readonly ASIN = new CodeType('2', 'ASIN');
  public static readonly PRODUCTNAME = new CodeType('3', '商品名');
  public static readonly JAN_ASIN = new CodeType('4', 'JAN＆ASIN');
  public static readonly JAN_PRODUCTNAME = new CodeType('5', 'JAN＆商品名');

  public static filterValues(): any {
    return [
      { value: this.JANCODE.value, text: i18n.t(this.JANCODE.text) },
      { value: this.ASIN.value, text: i18n.t(this.ASIN.text) },
      { value: this.PRODUCTNAME.value, text: i18n.t(this.PRODUCTNAME.text) },
      { value: this.JAN_ASIN.value, text: i18n.t(this.JAN_ASIN.text) },
      { value: this.JAN_PRODUCTNAME.value, text: i18n.t(this.JAN_PRODUCTNAME.text) },
    ];
  }

  public static values(): any {
    return [
      { value: this.JANCODE.value, text: i18n.t(this.JANCODE.text) },
      { value: this.ASIN.value, text: i18n.t(this.ASIN.text) },
      { value: this.PRODUCTNAME.value, text: i18n.t(this.PRODUCTNAME.text) },
      { value: this.JAN_ASIN.value, text: i18n.t(this.JAN_ASIN.text) },
      { value: this.JAN_PRODUCTNAME.value, text: i18n.t(this.JAN_PRODUCTNAME.text) },
    ];
  }

  // public static valueOf(value: string): CodeType {
  //   for (const v of this.values()) {
  //     if (v.value === value) {
  //       return v;
  //     }
  //   }
  //   return CodeType.JANCODE;
  // }

  private constructor(public readonly value: string, public readonly text: string) {}
  public getValue(): string { return this.value; }
  public getText(): string { return this.text; }
  public equals(other: CodeType): boolean { return (this.text === other.text) ? true : false; }
  public toString(): string { return `${this.text}(${this.text})`; }
}
